// Selectable app-logo colourways — the ROLODEX mark, supplied by the client as five SVGs
// (apps/web/public/logo-*.svg). The chosen variant drives the in-app LogoMark and the browser favicon.
// 'silver' is the neutral default. `glow` is the drop-shadow colour used on the login / boot screens.

export type LogoVariant = 'silver' | 'blue' | 'red' | 'green' | 'gold';

export interface LogoDef {
  label: string;
  src: string;
  glow: string;
}

export const LOGO_VARIANTS: Record<LogoVariant, LogoDef> = {
  silver: { label: 'Silver', src: '/logo-silver.svg', glow: 'rgba(150,150,160,.55)' },
  blue: { label: 'Blue', src: '/logo-blue.svg', glow: 'rgba(58,57,230,.70)' },
  red: { label: 'Red', src: '/logo-red.svg', glow: 'rgba(226,34,48,.65)' },
  green: { label: 'Green', src: '/logo-green.svg', glow: 'rgba(19,163,77,.65)' },
  gold: { label: 'Gold', src: '/logo-gold.svg', glow: 'rgba(217,194,92,.65)' },
};

export const LOGO_ORDER: LogoVariant[] = ['silver', 'blue', 'red', 'green', 'gold'];

/** resolve a (possibly untrusted / legacy, e.g. 'stock' or 'burgundy') stored value to a valid variant. */
export function logoDef(v: string | undefined | null): LogoDef {
  return (v && LOGO_VARIANTS[v as LogoVariant]) || LOGO_VARIANTS.silver;
}
